import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { Icon } from '@plone/volto/components';

// Interaktiv Custom Start
import bookmarkSVG from '../../../icons/favoriten.svg';
import { getBookmark, addBookmark, deleteBookmark } from '../../../actions';
import {
  doStringifySearchquery,
  querystringToTitle,
} from '../../../helpers/volto-bookmark';
// Interaktiv Custom Start

import config from '@plone/volto/registry';

/**
 * Add a bookmark to owners bookmark list
 */
const ToggleBookmarkActions = () => {
  const content = useSelector((state) => state.content?.data);
  const token = useSelector((state) => state.userSession?.token);
  const dispatch = useDispatch();
  const currentbookmark = useSelector(
    (state) => state.collectivebookmarks?.bookmark,
  );
  const bookmarkdelete = useSelector(
    (state) => state.collectivebookmarks?.delete || {},
  );
  const [group, setGroup] = useState('');

  // after deletion of bookmark (state.collectivebookmarks?.delete changed to 'loaded')
  React.useEffect(() => {
    if (token && bookmarkdelete === 'loaded') {
      const url = new URL(document.location);
      let uid = content?.UID;
      let grp = 'default_nogroup';
      if (uid) {
        let default_token = [
          { token: url.search ? 'default_search' : 'default_nogroup' },
        ];
        let grp_token =
          content?.[config.settings?.bookmarks?.bookmarkgroupfield] ||
          default_token;
        grp =
          grp_token && grp_token.length > 0
            ? grp_token[0].token || grp_token
            : 'default_search';
        setGroup(grp);
        dispatch(getBookmark(uid, grp, url.search));
      }
    }
  }, [dispatch, token, content, bookmarkdelete]);

  // TODO Make event listeners configurable for other implementations of searchkit / faceted search
  React.useEffect(function mount() {
    window.addEventListener(
      'searchkitQueryChanged',
      searchOnUrlQueryStringChanged,
    );

    return function unMount() {
      window.removeEventListener(
        'searchkitQueryChanged',
        searchOnUrlQueryStringChanged,
      );
    };
  });

  function searchOnUrlQueryStringChanged(event) {
    // event handler for searchkitQueryChanged event of searchkit
    const url = new URL(document.location);
    setGroup('default_search');
    dispatch(getBookmark(content.UID, 'default_search', url.search));
  }

  function toggleBookmarkHandler() {
    const url = new URL(document.location);
    let [uid, querystring] = [content.UID, url.search];

    let grp = group;

    if (currentbookmark) {
      dispatch(deleteBookmark(uid, grp, doStringifySearchquery(querystring)));
    } else {
      let payload = {
        querystringvalues: querystringToTitle(querystring),
      };
      dispatch(addBookmark(uid, grp, querystring, payload));
    }
  }

  // Interaktiv Custom Start
  return token ? (
    <Button
      icon
      basic
      id="toolbar-addbookmark"
      className="addbookmark"
      data-active={Boolean(currentbookmark)}
      aria-label={'Als Favorit setzen oder entfernen'}
      onClick={() => toggleBookmarkHandler()}
    >
      <Icon
        name={bookmarkSVG}
        size="30px"
        title={'Als Favorit setzen oder entfernen'}
      />
    </Button>
  ) : null;
  // Interaktiv Custom End
};

export default ToggleBookmarkActions;
